import { http } from './config';

export default {
    listUsers: () => {
        return http.get('api/admin/users');
    },
    listRoles: () => {
        return http.get('api/admin/roles');
    },
    updateUserRoles: (userId, roles) => {
        return http.put('api/admin/users/' + userId + '/roles', { roles });
    },
    createRole: (data) => {
        return http.post('api/admin/roles', data);
    },
    updateRole: (id, data) => {
        return http.put('api/admin/roles/' + id, data);
    },
    deleteRole: (id) => {
        return http.delete('api/admin/roles/' + id);
    }
};
